import { PaginationOutput } from "@core/logic/common/pagination-output";

export class BaseFilter {
  public id = "";
}

export interface BaseFilterList extends PaginationOutput {
  items: BaseFilter[];
}